import downloadFile, { downloadZip } from 'helper/downloadFile';
import buildDownloadFiles, { ObservedDataImages } from 'helper/products/observedData/buildDownloadFiles';

export default function useObservedDataImagesDownload(
  images: ObservedDataImages,
  isHeatmap: boolean,
  isFetching: boolean,
) {
  const files = buildDownloadFiles(images, isHeatmap);
  const downloadDisabled = isFetching || files.length === 0;

  const onDownloadClick = () => {
    if (downloadDisabled) return;

    // Uma figura so baixa direto; varias saem num pacote unico.
    if (files.length === 1) {
      downloadFile(files[0].content, files[0].filename);
      return;
    }

    const date = new Date();
    const zipFilename = `dados_observados_${date.toLocaleString('pt-BR').replace(/\/|:|,|\s/g, '_')}.zip`;
    downloadZip(files, zipFilename);
  };

  return {
    onDownloadClick,
    downloadDisabled,
  };
}
